/* Creazione del button per aprire il drawer */

import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import  ButtonMenu from '../DrawerButton/ButtonMenu'
import SelectPathComponent from '../SelectPathComponent/SelectPathComponent'
import './ButtonClose.css'
import { connect } from 'react-redux'
import {selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa} from '../../redux'
//import { setPageStateUpdate } from '@material-ui/data-grid';


function DrawerLeft(props) {
  

 /*  function ciao(){
    
      
 
    
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);



  if(urlParams.has("fromPlace") || urlParams.has("toPlace")){
    if(urlParams.get("fromPlace")!=="" || urlParams.get("toPlace")!=="" ){
          return true;
    } 
    else {
    return false;
    }
  }
  else 
  {
  return false;
  }






  } */
 //funzione per aprire o meno il drawer se sono presenti già fromplace e toplace
  function ciao(props){
    
    const queryString = window.location.search;
    
    const urlParams = new URLSearchParams(queryString);
    
    if((urlParams.has("fromPlace") /*  && urlParams.get("fromPlace")!=="" */)  || (urlParams.has("toPlace") /* && urlParams.get("toPlace")!=="" */) && !urlParams.has("tariffe") || urlParams.has("travel")){
     props.percorsoTariffa.percorsoTariffa = false
      props.percorsoDrawer.percorsoDrawer = true
      
      return true;
            
      } 
      else {
        return false;
      }
}
  // const classes = useStyles();
  const [open, setOpen] = React.useState(ciao(props));
  
  


  const queryString = window.location.search;
  
  const urlParams = new URLSearchParams(queryString);
  //props.changePercorsoDrawer(open)
  
  const handleDrawerClose = () => {
    //props.percorsoDrawer = open
      setOpen(false);
      //props.percorsoDrawer.percorsoDrawer = false
      //props.percorsoDrawer = open   

  };
  
  
  

  return (
    <div className={"root"}>
      
      <ButtonMenu openMenu={setOpen} button={props.value.buttonStyle} ></ButtonMenu>
      
      <Drawer
      transitionDuration={500}
        className={"drawer"}
        variant="persistent"
        anchor="left"
        open={open}
        
        classes={{
          paper: "drawerPaper",
        }}
      >       
        <SelectPathComponent callback={handleDrawerClose.bind(this)} parameters={props.value.parameters} search={props.search} httpProxy={props.httpProxy}/>   

      </Drawer>
      
    </div>
  );
}

const mapStateToProps = state => {
  return {
     
      markerStart2: state.markerStart2,
      markerEnd2: state.markerEnd2,
      nomeFermataStart:state.nomeFermataStart,
      nomeFermataEnd: state.nomeFermataEnd,
      percorsoDrawer : state.percorsoDrawer,
      percorsoTariffa :state.percorsoTariffa

  }
}

const mapDispatchToProps = dispatch => {
  return {
     
      markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
      markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
      changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
      changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
      changePercorsoDrawer: (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
      changePercorsoTariffa:(percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa))

  }
}




export default connect(mapStateToProps,mapDispatchToProps)(DrawerLeft)